import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './CardLayout.module.scss';

interface ICardLayoutProps extends PropsWithChildren {
  onClick: () => void;
  active: boolean;
}

/**
 * General and reusable interface for the card components used in SettingsPage/Billing page. It's clickable
 * @param children - The content to be displayed inside the card.
 * @param onClick - A function to be called when the card is clicked.
 * @param active - Indicates if the card is selected, which applies additional styling.
 * @returns A div element representing a card layout, which contains the given children and has an onClick handler.
 */
const CardLayout: FC<ICardLayoutProps> = ({ children, onClick, active }) => {
  return (
    <div
      onClick={onClick}
      className={classNames([styles.layout, active && styles.active])}
    >
      {children}
    </div>
  );
};

export { CardLayout };
